<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('cities.countries.edit', { id: vm.$route.params.countryId })
  }),
  computed: {
    ...mapState('citiesCountries', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('cities.title'), to: { name: 'cities.index' } },
      { text: vm.$t('cities.countries.title'), to: { name: 'cities.countries.index' } },
      { text: vm.$t('cities.countries.edit', { id: vm.$route.params.countryId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('citiesCountries/fetchItem', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('citiesCountries', ['createItem', 'updateItem'])
  }
}
</script>
